



































































































































































import Spinner from "@/components/Spinner.vue";
import Vue from "vue";
import { pii_state } from "./state";
import { PIIDashboardItem, PIIDataItem } from "./models";
import { state } from "../state";
import { computed } from "@vue/composition-api";
import { ICONS } from "@/common/icons.map";
import { SharedState } from "@/common/state";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
export default Vue.extend({
  props: ["is_loading", "date"],
  components: { SkeletonLoaderItem },
  setup(_, { emit }) {
    const { regulated_items, selected_sensitivities } = state;
    const { items } = pii_state;

    const on_count_click = (item: PIIDataItem) => {
      emit("item_clicked", item);
    };

    const all_pii = computed(() => {
      const spi: PIIDashboardItem = {
        title: "Sensitive Personal Information",
        items: regulated_items.value.map(([code, items]) => {
          // I need to extract out both th
          const label = SharedState.get_l0_by_code(code);
          return {
            type: "category",
            id: code,
            name: label ? label.labelName : "Microsoft Labels",
            icon: ICONS.L0_ICONS.get(code),
            items: items.map((d: any) => {
              d.type = "count";
              const l = SharedState.getInfoType(d.id);
              if (d.nested && d.nested.length > 0) {
                d.items = d.nested;
              }

              return d;
            }),
          };
        }),
      };

      return [spi, ...items.value];
    });

    return { all_pii, on_count_click, selected_sensitivities };
  },
});
